import React from 'react';
import { CheckSquare, Square, Download, Trash2, X } from 'lucide-react';
import './BulkActions.css';

/**
 * Componente per gestire azioni massive su record selezionati
 * 
 * @param {Object} props
 * @param {Array} props.selectedIds - Array di ID selezionati
 * @param {Number} props.totalCount - Numero totale di record disponibili
 * @param {Function} props.onSelectAll - Callback per seleziona/deseleziona tutti
 * @param {Function} props.onClearSelection - Callback per pulire selezione
 * @param {Array} props.actions - Array di azioni disponibili
 * @param {Boolean} props.allSelected - Se tutti i record sono selezionati
 * 
 * Esempio actions:
 * [
 *   {
 *     id: 'delete',
 *     label: 'Elimina',
 *     icon: Trash2,
 *     color: 'red',
 *     onClick: (selectedIds) => { ... }
 *   },
 *   {
 *     id: 'export',
 *     label: 'Esporta CSV',
 *     icon: Download,
 *     color: 'blue',
 *     onClick: (selectedIds) => { ... }
 *   }
 * ]
 */
const BulkActions = ({
  selectedIds = [],
  totalCount = 0,
  onSelectAll,
  onClearSelection,
  actions = [],
  allSelected = false
}) => {
  const selectedCount = selectedIds.length;
  const hasSelection = selectedCount > 0;

  if (!hasSelection) {
    return null;
  }

  return (
    <div className="bulk-actions-bar">
      <div className="bulk-actions-content">
        {/* Selection Info */}
        <div className="bulk-selection-info">
          <button
            onClick={onSelectAll}
            className="bulk-select-all-btn"
            title={allSelected ? 'Deseleziona tutti' : 'Seleziona tutti'}
          >
            {allSelected ? (
              <CheckSquare className="bulk-icon" />
            ) : (
              <Square className="bulk-icon" />
            )}
          </button>
          
          <span className="bulk-count">
            <strong>{selectedCount}</strong> {selectedCount === 1 ? 'elemento' : 'elementi'} selezionato{selectedCount !== 1 && 'i'}
            {totalCount > 0 && (
              <span className="bulk-total"> su {totalCount}</span>
            )}
          </span>

          <button
            onClick={onClearSelection}
            className="bulk-clear-btn"
            title="Pulisci selezione"
          >
            <X className="bulk-icon-sm" />
            Deseleziona
          </button>
        </div>

        {/* Actions */}
        <div className="bulk-actions-buttons">
          {actions.map(action => {
            const Icon = action.icon;
            return (
              <button
                key={action.id}
                onClick={() => action.onClick(selectedIds)}
                className={`bulk-action-btn bulk-action-${action.color || 'default'}`}
                disabled={action.disabled}
                title={action.title || action.label}
              >
                {Icon && <Icon className="bulk-icon-sm" />}
                <span>{action.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BulkActions;
